import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { brandEmail } from '../lib/brand';
import { BrandLogo } from '../components/BrandLogo';
import { platformName, supportEmail, siteMode } from '../lib/site';

const Login = ({ superAdminOnly = false }) => {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const platformSurface = ['app', 'admin', 'platform'].includes(siteMode());

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/auth/login', { email, password });
      login(response.data.token, response.data.user);
      toast.success('Welcome back!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" data-testid="login-page">
      <div className="login-card">
        <div className="login-logo">
          {platformSurface ? (
            <h1 data-testid="company-logo" style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', color: '#0F172A', margin: 0 }}>{platformName()}</h1>
          ) : <BrandLogo height={56} data-testid="company-logo" />}
          <p data-testid="app-subtitle">{superAdminOnly ? 'Super Admin Console' : platformSurface ? 'Staff sign-in' : 'Proposal Builder'}</p>
        </div>

        <form onSubmit={handleLogin} data-testid="login-form">
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <Label htmlFor="email" style={{ color: '#333', fontWeight: 600, fontSize: '13px', textTransform: 'uppercase' }}>Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="you@yourcompany.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="email-input"
              style={{ borderColor: '#ddd' }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: '24px' }}>
            <Label htmlFor="password" style={{ color: '#333', fontWeight: 600, fontSize: '13px', textTransform: 'uppercase' }}>Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="password-input"
              style={{ borderColor: '#ddd' }}
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={loading}
            data-testid="login-button"
            style={{ 
              background: '#e74c3c', 
              color: '#fff',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              padding: '12px 24px'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '12px', color: '#999' }}>
          {!superAdminOnly && (
            <p style={{ marginBottom: 8 }}>
              <a href="/forgot-password" data-testid="login-forgot-link" style={{ color: '#555', fontWeight: 600 }}>Forgot password?</a>
              {platformSurface && <> · <a href="/signup" data-testid="login-signup-link" style={{ color: '#4F46E5', fontWeight: 700 }}>Start a free trial</a></>}
            </p>
          )}
          <p>Need help? Contact {(platformSurface ? supportEmail() : brandEmail()) || 'your administrator'}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;